// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Actions
import { updateDebugTool } from '../store/debugToolActions';

// Components
import { DebugContext } from '../DebugTool';

// Styles
import './DebugGlobalRangeInput.scss';

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatchUpdateDebugTool: () => dispatch(updateDebugTool({ toolName: ownProps.toolName })),
});

let DebugGlobalRangeInput = (props) => {
    const {
        forceRender,
        globalObject,
        prop,
        onChange,
        className,
        dispatchUpdateDebugTool,
        // eslint-disable-next-line no-unused-vars
        toolName,
        // eslint-disable-next-line no-unused-vars
        toolEnabled,
        ...rest
    } = props;

    const onChangeHandler = (e) => {
        globalObject[prop] = e.target.value;
        onChange && onChange(e);
        forceRender();
        // Update the tool's lastUpdateTimestamp in the store to allow re-renders if necessary
        dispatchUpdateDebugTool();
    };

    return (
        <div className={classNames('DebugGlobalRangeInput DebugRangeInput', className)}>
            <input type="range" value={globalObject[prop]} {...rest} onChange={onChangeHandler} />
            <span className="value">{globalObject[prop]}</span>
        </div>
    );
};

DebugGlobalRangeInput.propTypes = {
    forceRender: PropTypes.func.isRequired,
    globalObject: PropTypes.object.isRequired,
    prop: PropTypes.string.isRequired,
    className: PropTypes.string,
    onChange: PropTypes.func,

    dispatchUpdateDebugTool: PropTypes.func,

    toolName: PropTypes.string,
    toolEnabled: PropTypes.bool,
};

DebugGlobalRangeInput = connect(null, mapDispatchToProps)(DebugGlobalRangeInput);

const WrappedDebugGlobalRangeInput = (props) => (
    <DebugContext.Consumer>{(context) => <DebugGlobalRangeInput {...context} {...props} />}</DebugContext.Consumer>
);

export default WrappedDebugGlobalRangeInput;
